import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateExclusion = (resource, id, lotId, values) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/${lotId}/exclusions`, values);
};

export const useUpdateExclusion = (resource, id, lotId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateExclusion(resource, id, lotId, values),
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
